import React, { useEffect, useState } from 'react';
import {
    BarChart,
    Bar,
    XAxis,
    Tooltip,
    Rectangle,
    ResponsiveContainer,
} from 'recharts';

import './FrequenciaAlunos.css';
import { teacherAPI } from '../../../api/aulasApi';

const AlunosPresentesChart = () => {
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchAttendance = async () => {
            try {
                const response = await teacherAPI.getAttendace();
                setData(response.data);
            } catch (error) {
                console.error('Erro ao buscar dados de presença:', error);
            } finally {
                setLoading(false);
            }
        };

        fetchAttendance();
    }, []);

    if (loading) {
        return <p>Carregando gráfico de frequência...</p>;
    }

    return (
        <div className="chart-container">
            <div className="chart-title">Alunos Presentes na Semana</div>
            <ResponsiveContainer width="101%" height="100%">
                <BarChart
                    data={data}
                    margin={{
                        right: 10,
                        left: 10,
                    }}
                >
                    <defs>
                        <linearGradient id="blueGradient" x1="0" y1="0" x2="0" y2="1">
                            <stop offset="0%" stopColor="#0078D5" stopOpacity={1} />
                            <stop offset="100%" stopColor="#47BFFE" stopOpacity={1} />
                        </linearGradient>
                    </defs>
                    <XAxis dataKey="name" axisLine={false} />
                    <Tooltip />
                    <Bar
                        stroke="none"
                        dataKey="presentes"
                        fill="url(#blueGradient)"
                        radius={[5, 5, 0, 0]}
                        activeBar={<Rectangle fill="#3a91d3" radius={[5, 5, 0, 0]} />}
                        name="Alunos Presentes"
                    />
                </BarChart>
            </ResponsiveContainer>
        </div>
    );
};

export default AlunosPresentesChart;
